import { Wizard } from './Wizard'
import { Step } from './Step'
import { WizardConsumer, useWizard } from './context'

Wizard.Step = Step

export { Wizard, Step, WizardConsumer, useWizard }
